module.exports = __webpack_public_path__ + "img/asset-tracker-logo.fd986699.png";